import * as Yup from 'yup'

const billServiceValidator = Yup.object ({
  service: Yup.object ().nullable ().required ('Selecione o serviço'),
  professional: Yup.object ().nullable (),
  custom_price: Yup.number (),
  custom_comission_percentage: Yup.number (),
})

export default billServiceValidator
